import React from 'react';
import './SecondaryButton.css';

const SecondaryButton = ({ onClick, children }) => (
  <button className="secondary-button" onClick={onClick}>
    {children}
  </button>
);

export default SecondaryButton;
